import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import OptinPage from './pages/OptinPage';
import TrainingPage from './pages/TrainingPage';
import ThankYouPage from './pages/ThankYouPage';
import BookPage from './pages/BookPage';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-neutral-950 text-white antialiased selection:bg-amber-300/30 selection:text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/apply" element={<OptinPage />} />
          <Route path="/optin" element={<OptinPage />} />
          <Route path="/register" element={<OptinPage />} />
          <Route path="/training" element={<TrainingPage />} />
          <Route path="/vsl" element={<TrainingPage />} />
          <Route path="/thankyou" element={<ThankYouPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/book" element={<BookPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
